import { IPosIn } from "../../models/input/agendaApi/IPosIn";
import { ISaleIn } from "../../models/input/agendaApi/ISaleIn";
import * as ApiWithToken from "../callApiWithToken";


const salesService = {
    getSales:async function(posCode:string, brandId:number, date:string, languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetSale?posCode=${posCode}&brandId=${brandId}&date=${date}&languageID=${languageId}`);
    },
    insertSale:async function(saleInsertIn: ISaleIn[]){
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `Sale/InsertSale`, saleInsertIn);
    },
    GetImpresionProducts:async function(posCode:string, brandId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetImpresionProducts?posCode=${posCode}&brandId=${brandId}`);
    },
    GetCategoriesByLanguage:async function(languageId:number, posCode:string, brandId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetCategoriesByLanguage?LanguageID=${languageId}&posCode=${posCode}&brandID=${brandId}`);
    },
    GetSubcategoriesByLanguage:async function(languageId:number){
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `Sale/GetSubcategoriesByLanguage?LanguageID=${languageId}`);
    },
    getBrandsByPos: async function(posCode:string){
        return  ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API +  `Sale/GetBrandsByPos?posCode=${posCode}`);
    }
}
export default salesService;
